var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.08057C17.5 14.9139 10 19.9139 10 19.9139C10 19.9139 2.5 14.9139 2.5 9.08057C2.5 7.09144 3.29018 5.18379 4.6967 3.77727C6.10322 2.37074 8.01088 1.58057 10 1.58057C11.9891 1.58057 13.8968 2.37074 15.3033 3.77727C16.7098 5.18379 17.5 7.09144 17.5 9.08057Z",
    stroke: "#0A142F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5806C11.3807 11.5806 12.5 10.4613 12.5 9.08057C12.5 7.69985 11.3807 6.58057 10 6.58057C8.61929 6.58057 7.5 7.69985 7.5 9.08057C7.5 10.4613 8.61929 11.5806 10 11.5806Z",
    stroke: "#0A142F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.74707)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.4c4aab289be18be5b9eafeadb5566561.svg";
export { ForwardRef as ReactComponent };